// extracted by mini-css-extract-plugin
export default {"column":"styles_column__uXIIj"};